import {Shower} from "../../parts/shower";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {IntermediatePart} from "../../intermediatePart";

export default class TubSpout extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'tub_spout';
    this.partName = 'Tub Spout';
    this.translateId = "visualizer.bathroom.shower.tub_spout";
    this.canBeDisabled = true;
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    const showerComboParent = showerParent.layout.parts[ShowerTubCombo.id];
    if (!showerParent.showerTubComboIsActive() || showerComboParent.bottomTub !== "replacement_tub") {
      return true
    }
    if (showerParent.showerFixture && showerParent.showerFixture.activeFeature && showerParent.showerFixture.activeFeature.metaData["MountType"]
      && showerParent.showerFixture.activeFeature.metaData["MountType"].includes("T")) { // S and 0 is ok
      return true;
    }
    return false
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerSize = showerParent.showerSize();
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      })
    }
    return conditions
  }

  canDisplayDemoPoint() {
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerComboParent = layout.parts[ShowerTubCombo.id];
    return showerParent.showerTubComboIsActive() && showerComboParent.bottomTub === "replacement_tub";
  }

}
